import React from 'react';

import { i18n } from 'config/locales';
import Subsection from 'components/Section/shared/Subsection';
import {
  SF852013, SF85, SF85P, SF85PS, SF86
} from 'constants/formTypes';
import { isPVQForm } from 'helpers/form';
import { SignatureValidator } from '../../../validators';
import Signature from './Signature';

// TODO: Rename this component and relevant references (frontend and backend)
// This section of the application was improperly named and never got fixed.
// See https://github.com/ryanhofdotgov/e-QIP-prototype-truetandem/issues/657#issuecomment-349350305
export default class AdditionalComments extends Subsection {
  constructor(props) {
    super(props);

    this.update = this.update.bind(this);
    this.updateSignature = this.updateSignature.bind(this);
  }

  update(queue) {
    this.props.onUpdate({
      Signature: this.props.Signature,
      ...queue,
    });
  }

  updateSignature(values) {
    this.update({ Signature: values });
  }

  render() {
    const isPvq = isPVQForm(this.props.formType);

    return isPvq ? (
      <div className="additional-comments">
        {i18n.m('releasesPvq.certification.contents')}
        <Signature
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...this.props.Signature}
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          LegalName={this.props.LegalName}
           // eslint-disable-next-line @typescript-eslint/unbound-method
          onError={this.handleError}
          // eslint-disable-next-line @typescript-eslint/unbound-method
          onUpdate={this.updateSignature}
        />
      </div>
    ) : (
      <div className="additional-comments">
        {this.props.formType === SF86
          && i18n.m('releases.additionalComments.certificationContents')}
        {[SF852013, SF85].includes(this.props.formType) && i18n.m('releasesSF85.certification.contents')}
        {[SF85P].includes(this.props.formType) && i18n.m('releasesSF85P.certification.contents')}
        {[SF85PS].includes(this.props.formType) && i18n.m('releasesSF85PS.certification.contents')}
        <Signature
          {...this.props.Signature}
          LegalName={this.props.LegalName}
          onUpdate={this.updateSignature} // eslint-disable-line @typescript-eslint/unbound-method
          onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
        />
      </div>
    );
  }
}

AdditionalComments.defaultProps = {
  Signature: {},
  LegalName: {},
  section: 'releases',
  subsection: 'comments',
  dispatch: () => { },
  validator: (data) => new SignatureValidator(data).isValid(),
  onUpdate: () => { },
  onError: (value, arr) => arr,
};
